export default "__VITE_PUBLIC_ASSET__c0551aac__"